import { jsxs, jsx } from 'react/jsx-runtime';
import { Space } from '@sravni/react-design-system';
import { Heading } from '@sravni/react-design-system/lib/Typography';
import { Rating } from '../Rating/Rating.js';
import modules_9ece3fb3 from './CardTitle.module.scss.js';

var CardTitle = function (_a) {
    var title = _a.title, subtitle = _a.subtitle, icon = _a.icon, titleClassName = _a.titleClassName, className = _a.className, rating = _a.rating, reviews = _a.reviews;
    return (jsxs(Space, { justify: "space-between", children: [jsxs(Space, { className: className, size: 12, align: "center", children: [jsx("div", { className: modules_9ece3fb3.icon, children: icon }), jsxs(Space, { size: 4, direction: "vertical", children: [jsx(Heading, { level: 6, className: titleClassName, children: title }), subtitle] })] }), !!rating && !!reviews && jsx(Rating, { rating: rating, reviews: reviews })] }));
};

export { CardTitle };
//# sourceMappingURL=CardTitle.js.map
